export default __webpack_public_path__ + "static/media/setup_analytics.d946c7ea.svg";